module.exports = __webpack_public_path__ + "img/BIG_SCREEN_DASHBOARD.617e8d69.png";